let language = {
    PRODUCT_PRICE_TABLE_QTY: "数量",
    PRODUCT_PRICE_TABLE_US_COUNTRY_PRICE: "美国",
    PRODUCT_PRICE_TABLE_OTHER_COUNTRY_PRICE: "其他国家",
};

export { language }
